export default function Alert() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28"
        cy="28"
        r="25.7895"
        stroke="#F77D7D"
        strokeWidth="4.42105"
      />
      <path
        d="M28.0398 31.2723C27.4975 31.2723 27.0731 31.1073 26.7666 30.7772C26.46 30.4471 26.2714 29.9637 26.2007 29.3271L25.0689 17.2311C24.951 16.17 25.1514 15.3212 25.6701 14.6845C26.1889 14.0243 26.9788 13.6942 28.0398 13.6942C29.0537 13.6942 29.82 14.0243 30.3388 14.6845C30.8575 15.3212 31.0579 16.17 30.94 17.2311L29.8082 29.3271C29.7375 29.9637 29.5489 30.4471 29.2423 30.7772C28.9594 31.1073 28.5586 31.2723 28.0398 31.2723ZM28.0398 39.1241C27.0967 39.1241 26.3421 38.8412 25.7762 38.2753C25.2339 37.7094 24.9628 36.9784 24.9628 36.0824C24.9628 35.21 25.2339 34.5026 25.7762 33.9603C26.3421 33.3944 27.0967 33.1115 28.0398 33.1115C28.983 33.1115 29.7139 33.3944 30.2327 33.9603C30.775 34.5026 31.0461 35.21 31.0461 36.0824C31.0461 36.9784 30.775 37.7094 30.2327 38.2753C29.7139 38.8412 28.983 39.1241 28.0398 39.1241Z"
        fill="#F77D7D"
      />
    </svg>
  )
}
